export enum StreamCompositionType {
  MASS = 'Mass',
  VOLUME = 'Volume',
  DISTILLATION = 'Distillation',
}
